// base
import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import TransactionsComponentTable from "./TransactionsComponentTable";
import ContractTransactionsComponentTable from "./ContractTransactionsComponentTable";
import ContractTransfers from "../Contract/ContractTransfers";
import ContractTransfersTable from "./ContractTransfersTable";

const TransactionsComponent = (props) => {
  //TODO Type에 따라서 보여지는 table이 다름
  if (props.contractTx) {
    if (props.type && props.type === "ARC20") {
      return <ContractTransfersTable props={props} />;
    } else {
      return <ContractTransactionsComponentTable props={props} />;
    }
  } else if (!props.tab) {
    return <TransactionsComponentTable props={props} />;
  } else {
    return (
      <div style={{ widthh: "100%", overflowY: "auto" }}>
        <Tabs
          defaultIndex={0}
          onSelect={(index) => props.tabOnSelect(index)}
          style={{ minWidth: "500px" }}
        >
          <TabList>
            <Tab>General Transactions</Tab>
            <Tab>Join Transactions</Tab>
            <Tab>Contract</Tab>
          </TabList>
          <TabPanel>
            <TransactionsComponentTable props={props} txType="transfer" />
          </TabPanel>
          <TabPanel>
            <TransactionsComponentTable props={props} txType="jointx" />
          </TabPanel>
          <TabPanel>
            <TransactionsComponentTable props={props} txType="contract" />
          </TabPanel>
        </Tabs>
      </div>
    );
  }
};

TransactionsComponent.defaultProps = {
  tab: false,
  pageName: "",
  type: "full",
  transactions: [],
};

export default TransactionsComponent;
